/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { ApolloClient, InMemoryCache } from '@apollo/client';
import config from '../../config';

const GraphQlClient = new ApolloClient({
  uri: config.graphCMSURI as string,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${config.graphCMSToken}`
  }
});
export default GraphQlClient;

